module.exports = __webpack_public_path__ + "static/media/logo.7cef7eca.png";